export class LoadableSubscription {
  protected _loadFn: any;

  protected _opts: any;

  protected _callbacks: Set<any>;

  protected _onRenderedCallbacks: Set<any>;

  protected _delay: NodeJS.Timeout;

  protected _timeout: NodeJS.Timeout;

  protected _res: any;

  protected _state: { timedOut: boolean; pastDelay: boolean } & any;

  constructor(loadFn, opts) {
    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._onRenderedCallbacks = new Set();
    this._delay = null;
    this._timeout = null;

    this.retry();
  }

  promise() {
    return this._res.promise;
  }

  get error() {
    return this._res.error;
  }

  get loading() {
    return this._res.loading;
  }

  get rendered() {
    return this._state.rendered;
  }

  retry() {
    this._clearTimeouts();
    this._res = this._loadFn(this._opts.loader);

    this._state = {
      pastDelay: false,
      timedOut: false,
      rendered: false,
    };

    const { _res: res, _opts: opts } = this;

    if (res.loading) {
      if (typeof opts.delay === 'number') {
        if (opts.delay === 0) {
          this._state.pastDelay = true;
        } else {
          this._delay = setTimeout(() => {
            this._update({
              pastDelay: true,
            });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === 'number') {
        this._timeout = setTimeout(() => {
          this._update({ timedOut: true });
        }, opts.timeout);
      }
    }

    this._res.promise
      .then(() => {
        this._update({});
        this._clearTimeouts();
      })
      .catch((_err) => {
        this._update({});
        this._clearTimeouts();
      });
    this._update({});
  }

  _update(partial) {
    this._state = {
      ...this._state,
      error: this._res.error,
      loaded: this._res.loaded,
      loading: this._res.loading,
      ...partial,
    };
    this._callbacks.forEach((callback) => callback());
  }

  _clearTimeouts() {
    clearTimeout(this._delay);
    clearTimeout(this._timeout);
  }

  getCurrentValue() {
    return this._state;
  }

  subscribe(callback) {
    this._callbacks.add(callback);
    return () => {
      this._callbacks.delete(callback);
    };
  }

  subscribeOnRendered(callback) {
    this._onRenderedCallbacks.add(callback);
    return () => {
      this._onRenderedCallbacks.delete(callback);
    };
  }

  onRendered() {
    this._state.rendered = true;
    this._onRenderedCallbacks.forEach(callback => callback());
  }
}
